import { render, staticRenderFns } from "./Improvement.vue?vue&type=template&id=484c3149"
import script from "./Improvement.vue?vue&type=script&lang=js"
export * from "./Improvement.vue?vue&type=script&lang=js"
import style0 from "./Improvement.vue?vue&type=style&index=0&id=484c3149&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports